import React from "react";
import { useParams, useNavigate } from "react-router-dom";
import { CandidateDetailView, AcceptedPageShell, useRequireUser } from "./Acceptedcandidatespage";

// Standalone route /accepted-candidates/:candidateId. Renders the same detail view the
// list uses in-page (profile card, documents, in-page preview + download), on its own
// themed canvas with PAGE_PADDING.
export default function AcceptedCandidateDetail() {
  const { candidateId } = useParams();
  const navigate = useNavigate();
  useRequireUser(true);

  return (
    <AcceptedPageShell standalone>
      <CandidateDetailView
        candidateId={candidateId}
        onBack={() => navigate("/accepted-candidates")}
      />
    </AcceptedPageShell>
  );
}
